import { useInitMicrophonesDevices } from '@core/devices/components/DevicesTest/MicrophoneTest/hooks';
import { useInitWebcamDevices } from '@core/devices/components/DevicesTest/WebcamTest/hooks';
import { useEffect } from 'react';
import { MytaverseLogger } from '@helpers/logger';

const MobileExternalKeyboardDeviceControls = () => {
  useEffect(() => {
    MytaverseLogger.log('mic and camera permissions initialized');
  }, []);

  useInitMicrophonesDevices();
  useInitWebcamDevices();

  return <></>;
};

export default MobileExternalKeyboardDeviceControls;
